<template>
    <dialog-shell
        :title="$wordList.ProperAllTextConfirmation"
        footerType="customer"
    >
        <processing @success="$emit('success')" :pay-jump-url="payJumpUrl"></processing>
    </dialog-shell>
</template>

<script>
import { defineComponent } from 'vue';
import processing from '../subscription/module/pay/processing.vue';

export default defineComponent({
    components: {
        processing
    },
    props: {
        payJumpUrl: {
            type: String,
            required: ''
        }
    },
    setup(props) {
        console.log(props.payJumpUrl);
        return {

        };
    }
});
</script>
